module.exports = __webpack_public_path__ + "img/hw.85740b97.png";